import { MenuService } from './../../../services/app.menu.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { InnerPageLayoutComponent } from './inner-page-layout.component';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { BaseService } from 'src/app/services/common/base.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first, Subscription } from 'rxjs';
@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
})
export class AppTopBarComponent implements OnInit {
  userName: any;
  wrongNotificationCheck: boolean = true;
  selectedLang :any;
  items: MenuItem[];
  date: any;
  ipAddress: any;
  loginId: any;
  status: any;
  selectYear:any;
  financialYears:any[]=[]
  selectedYear:any

  constructor(
    public router: Router,
    public appMain: InnerPageLayoutComponent,
    public authService: AuthenticationService,
    private translateService: TranslateService,
    private menuService: MenuService,
    private ipService: IpAddressService,
    private activityRecordService : ActivityRecordService,
    private service:BaseService,
    private reportsService:ReportsService,
  ) {}
  ngOnInit() {
    if(sessionStorage.getItem('yearList')){
      this.financialYears=JSON.parse(sessionStorage.getItem('yearList'))
      
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
      let year=sessionStorage.getItem('financialYear')
      // console.log(year,"yuear$$$$$")
      // console.log(this.selectedYear)
      this.selectedYear={name:year,code:year}
    }
    else{
      this.reportsService.getFinanacialYearList()
    .pipe(first())
    .subscribe({
      next: (data) => {
        // console.log(data,"data1233")
        data.forEach((e:any)=>{
          let year={name:e.FinancialYears,code:e.FinancialYears}
          // console.log(year,"year")
          // console.log(this.financialYears,"this.financialYears")
          this.financialYears.push(year)
          

        })
        this.selectedYear={...this.financialYears[1]}
        // console.log(this.selectedYear,"this.selectedYear")
        sessionStorage.setItem('yearList',  JSON.stringify(this.financialYears))
        sessionStorage.setItem('financialYear',this.selectedYear.code)
     let a= sessionStorage.getItem('financialYear')
    //  console.log(a,"aaaaaa")
        this.service.changeFinancialYear(this.selectedYear.code)

       
      }})
    }    
    if(localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      this.translateService.use(this.selectedLang .code)
    }
    this.getLoginId();
    if (!this.userName) {
      this.userName = sessionStorage.getItem('newUserName');
    }
    let farmerName = sessionStorage.getItem('loginUserName');
    if (farmerName) {
      this.userName = farmerName;
    }
    this.items = [
      {
        label: 'Logout',
        icon: 'pi pi-fw pi-sign-in',
        command: () => {
          this.logOut();
          //  const [ngClass]="{'position': sticky}";
        },
      },
    ];
    this.menuService.userName$.subscribe((data) => {
      // console.log('SET USERNAME', data);
      sessionStorage.setItem('newUserName', data);
      this.userName = data;
    });
  }

  getLoginId(){
    if (sessionStorage.getItem('isFarmerLogin') == '1') {
      this.loginId = sessionStorage.getItem('farmerPh');
    } else {
      let sessionToken = sessionStorage.getItem('token');
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.loginId = JSON.parse(payload)?.sub;
    }
  }

  logOut() {
    this.activityRecordService.activityRecord(this.loginId, 'logout', '', new Date(), 'Success');
    window.sessionStorage.removeItem('farmerDetails');
    sessionStorage.removeItem('farmerPh');
    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('farmerPh');
    sessionStorage.removeItem('isFarmerLogin');
    sessionStorage.removeItem('isAtalBhujal');
    sessionStorage.clear();
    this.getInitialToken();
  }

  getInitialToken() {
    this.authService.getInitialToken().subscribe((response: any) => {
      if (response) {
        sessionStorage.setItem('auth_token', response.authToken);
        this.router.navigate(['/home']);
      }
    });
  }
  languageChange(event) {
   localStorage.setItem('lang', JSON.stringify(event.value))
       this.translateService.use(event.value.code)
  }
  
yearChange(event) {
  localStorage.setItem('Financial_year', JSON.stringify(event.value))
      // this.translateService.use(event.value.code)
      // console.log(event.value)
      
      this.service.changeFinancialYear(event.value.code)
 }
}
